// Suppress external browser extension runtime errors (e.g., TronLink / MetaMask inpage conflicts)
if (typeof window !== 'undefined') {
  window.addEventListener(
    'error',
    (event) => {
      if (
        (event.filename &&
          (event.filename.includes('chrome-extension://') ||
            event.filename.includes('moz-extension://'))) ||
        (event.message && event.message.includes('tronWeb'))
      ) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true,
  );
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
